<template>
  <option-manager :storeId="storeId" :menuDraftVariation="menuDraftVariation" :questionId="questionId" />
</template>

<script>
import OptionManager from '../OptionsManager'
export default {
  props: {
    storeId: String,
    menuDraftVariation: String,
    questionId: String
  },
  components: {
    OptionManager
  }
}
</script>
